import { generateStripeState } from '../helper'

const options = {
  api: {
    list:   () => `/api/stripe/plans`,
    delete: ({ id }) => `/api/stripe/plan/${id}`,
    update: ({ id }) => `/api/stripe/plan/${id}`,
    create: () => `/api/stripe/plan`
  },
  state: {
    collectionName: 'plans'
  },
  getters: {
    getPagination: 'getPlanPagination',
    getCollection: 'getPlans'
  },
  actions: {
    list: 'listPlans',
    delete: 'deletePlan',
    update: 'updatePlan',
    create: 'createPlan'
  },
  mutationKey: 'PLAN', // must be unique
}

const {
  state: stripeState,
  getters: stripeGetters,
  actions: stripeActions,
  mutations: stripeMutations
} = generateStripeState(options)

export default {
  state:{
    ...stripeState
  },
  getters: {
    ...stripeGetters
  },
  actions:{
    ...stripeActions,
    async archivePlan({ dispatch }, data) {
      const { id } = data
      const payload = { id, active: false }

      const plan = await dispatch('updatePlan', payload)

      return plan
    },
    async unarchivePlan({ dispatch }, data) {
      const { id } = data
      const payload = { id, active: true }

      const plan = await dispatch('updatePlan', payload)

      return plan
    }
  },
  mutations:{
    ...stripeMutations
  }
}
